import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

import auth from "./modules/auth";
import loading from "./modules/loading";
import users from "./modules/users";
import sidebar from "./modules/sidebar";
import roles from "./modules/roles";
import menus from "./modules/menus";
import rules from "./modules/rules";
import access_menus from "./modules/access_menus";
import personalities from "./modules/personalities";
import scores from "./modules/scores";
import classes from "./modules/classes";
import aspect from "./modules/aspect";
import students from "./modules/students";
import teachers from "./modules/teachers";
import income from "./modules/income";
import fee_type from "./modules/fee_type";
import fee from "./modules/fee";
import payment from "./modules/payment";
import expense_type from "./modules/expense_type";
import expense from "./modules/expense";
import transactions from "./modules/transactions";
import questions from "./modules/questions";
import questionDetail from "./modules/questionDetail";
import rooms from "./modules/rooms";
import register from "./modules/register";
import staff from "./modules/staff";
import store_file from "./modules/store_file";
import subjects from "./modules/subjects";
import teacher_subjects from "./modules/teacher_subjects";
import tahun_ajaran from "./modules/tahun_ajaran";
import teacher_classes from "./modules/teacher_classes";
import enrollment_student_classes from "./modules/enrollment_student_classes";
import enrollment_teacher_classes from "./modules/enrollment_teacher_classes";
import home from "./modules/home";
import programs from "./modules/programs";
import globals from "./modules/globals";
import pendidikan from "./modules/pendidikan";
import transportasi from "./modules/transportasi";
import regions from "./modules/regions";
import profile from "./modules/profile";
import events from "./modules/events";
import silabus from "./modules/silabus";
import kegiatan_belajar_mengajar from "./modules/kegiatan_belajar_mengajar";
import settings from "./modules/settings";
import type_classes from "./modules/type_classes";
import provinces from "./modules/provinces";
import attendances_teacher from "./modules/attendances_teacher";
import attendances_student from "./modules/attendances_student";
import ujian from "./modules/ujian";
import schedule from "./modules/schedule";
import days from "./modules/days";
import subject_types from "./modules/subject_types";
import kegiatan_web from "./modules/kegiatan_web";
import program_web from "./modules/program_web";
import gallery_web from "./modules/gallery_web";
import errors from "./modules/errors";
import audio_web from "./modules/audio_web";
import rekening from "./modules/rekening";
import iuran from "./modules/iuran";
import pembayaran_global from "./modules/pembayaran_global";
import jenis_iuran from "./modules/jenis_iuran";

Vue.use(Vuex);

const secureLS = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "vue-auth-persist",
});

const authState = createPersistedState({
  key: "auth-persist-state",
  paths: ["auth.captcha"],
  storage: {
    getItem: (key) => secureLS.get(key),
    setItem: (key, value) => secureLS.set(key, value),
    removeItem: (key) => secureLS.remove(key),
  },
});

const sidebarState = createPersistedState({
  key: "sidebar-persist-state",
  paths: ["sidebar.sidebar"],
  storage: {
    getItem: (key) => secureLS.get(key),
    setItem: (key, value) => secureLS.set(key, value),
    removeItem: (key) => secureLS.remove(key),
  },
});

const tokenState = createPersistedState({
  key: "token-persist-state",
  paths: ["auth.token"],
  storage: {
    getItem: (key) => secureLS.get(key),
    setItem: (key, value) => secureLS.set(key, value),
    removeItem: (key) => secureLS.remove(key),
  },
});

const refreshTokenState = createPersistedState({
  key: "refresh-token-persist-state",
  paths: ["auth.refresh_token"],
  storage: {
    getItem: (key) => secureLS.get(key),
    setItem: (key, value) => secureLS.set(key, value),
    removeItem: (key) => secureLS.remove(key),
  },
});
const rememberMeState = createPersistedState({
  key: "remember-me-persist-state",
  paths: ["auth.form.remember_me"],
  storage: {
    getItem: (key) => secureLS.get(key),
    setItem: (key, value) => secureLS.set(key, value),
    removeItem: (key) => secureLS.remove(key),
  },
});

const profileState = createPersistedState({
  key: "profile-persist-state",
  paths: ["auth.user"],
  storage: {
    getItem: (key) => secureLS.get(key),
    setItem: (key, value) => secureLS.set(key, value),
    removeItem: (key) => secureLS.remove(key),
  },
});

export default new Vuex.Store({
  modules: {
    home: home,
    auth: auth,
    loading: loading,
    users: users,
    sidebar: sidebar,
    roles: roles,
    menus: menus,
    rules: rules,
    access_menus: access_menus,
    personalities: personalities,
    scores: scores,
    classes: classes,
    aspect: aspect,
    students: students,
    teachers: teachers,
    income: income,
    fee_type: fee_type,
    fee: fee,
    payment: payment,
    expense_type: expense_type,
    expense: expense,
    transactions: transactions,
    questions: questions,
    rooms: rooms,
    register: register,
    staff: staff,
    questionDetail: questionDetail,
    store_file: store_file,
    subjects: subjects,
    teacher_subjects: teacher_subjects,
    tahun_ajaran: tahun_ajaran,
    teacher_classes: teacher_classes,
    enrollment_student_classes: enrollment_student_classes,
    enrollment_teacher_classes: enrollment_teacher_classes,
    programs: programs,
    globals: globals,
    pendidikan: pendidikan,
    transportasi: transportasi,
    regions: regions,
    profile: profile,
    events: events,
    silabus: silabus,
    kegiatan_belajar_mengajar: kegiatan_belajar_mengajar,
    settings: settings,
    attendances_teacher: attendances_teacher,
    attendances_student: attendances_student,
    type_classes: type_classes,
    provinces: provinces,
    ujian: ujian,
    schedule: schedule,
    days: days,
    subject_types: subject_types,
    kegiatan_web: kegiatan_web,
    program_web: program_web,
    gallery_web: gallery_web,
    errors: errors,
    audio_web: audio_web,
    rekening: rekening,
    iuran: iuran,
    pembayaran_global: pembayaran_global,
    jenis_iuran: jenis_iuran,
  },
  plugins: [
    authState,
    sidebarState,
    tokenState,
    rememberMeState,
    refreshTokenState,
    profileState,
  ],
});
